import React from 'react';

import { useSportsbookState, useSportsbookStateUpdate } from '@atlas/core';
import { SportsbookNavigation } from '@atlas/routing';

export const DefaultSportsbookNavigation = ({ children }) => {
  const sportsbookStateUpdate = useSportsbookStateUpdate();
  const { selectedCategoryUrlName, selectedSportUrlName, selectedTournamentUrlName } =
    useSportsbookState();

  return (
    <SportsbookNavigation
      selectedCategoryUrlName={selectedCategoryUrlName}
      selectedSportUrlName={selectedSportUrlName}
      selectedTournamentUrlName={selectedTournamentUrlName}
      sportsbookStateUpdate={sportsbookStateUpdate}
    >
      {children}
    </SportsbookNavigation>
  );
};
